import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Paginator } from 'front-onceforall-core';
import Card from './card';
import CreateProjectButton from '../buttons/createProjectButton';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ProjectListView = props => {
  function getRow(project) {
    const row = props.organisations.find(orga => orga.id === project.creatorOrganisationId);
    if (row) {
      return /*#__PURE__*/_jsx(Card, {
        creatorOrganisationName: row.fullName,
        project: project,
        onClick: handleLinkProject(project.id)
      }, project.id);
    }
  }
  function handleLinkProject(projectId) {
    return event => {
      event.preventDefault();
      event.stopPropagation();
      props.history.push(`/project/${projectId}`);
    };
  }
  const rows = props.projects.map(project => getRow(project));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.loading && /*#__PURE__*/_jsx("div", {
      className: "loading-overlay"
    }), rows.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [rows, /*#__PURE__*/_jsx(Paginator, {
        totalItems: props.projectsCount,
        pageSize: props.pageSize,
        currentPage: props.pageNumber,
        onChangePage: props.onPageChange
      })]
    }), rows.length === 0 && /*#__PURE__*/_jsx("div", {
      className: "table-without-result",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex-container column center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "no-project-message mb-5",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "project.noProjects"
          })
        }), /*#__PURE__*/_jsx(CreateProjectButton, {
          icon: "folder-plus"
        })]
      })
    })]
  });
};
ProjectListView.propTypes = {
  history: PropTypes.object.isRequired,
  organisations: PropTypes.array.isRequired,
  projects: PropTypes.array.isRequired,
  projectsCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageNumber: PropTypes.number,
  pageSize: PropTypes.number,
  loading: PropTypes.bool.isRequired
};
ProjectListView.defaultProps = {
  pageNumber: 0,
  pageSize: 10
};
export default withRouter(ProjectListView);